import { render, staticRenderFns } from "./changeTPwd.vue?vue&type=template&id=e56de660"
import script from "./changeTPwd.vue?vue&type=script&lang=js"
export * from "./changeTPwd.vue?vue&type=script&lang=js"
import style0 from "./changeTPwd.vue?vue&type=style&index=0&id=e56de660&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports